<style type="text/css" scoped>
	article {
		max-width: 1000px;
		margin: auto;
	}

	.form-details {
		margin-top: 30px;
		padding: 15px;
		background-color: #6c757d;
		color: white;
	}

	@media print {
		.print-button {
			display: none;
		}
	}
</style>
<template>
<article>
	<div class="letterhead d-flex flex-row justify-content-between align-items-center">
		<img v-if="companyLogoSrc" :src="companyLogoSrc" class="logo mr-3">
		<div>
			<h3 v-if="'FormChildTemplate' in form && form.FormChildTemplate">
				{{ form.FormChildTemplate.description }}
				<div>
					<small class="text-muted">
						{{ form.FormChildTemplate.FormTemplate.title }} <br>
						#{{ form.formNum }}
					</small>
				</div>
			</h3>
			<button class="btn btn-light print-button" v-on:click="printPage">
				<i class="fa fa-print"></i>
				Print
			</button>
		</div>
	</div>
	<div class="form-details">
		<table>
			<tr v-if="form.Job && 'id' in form.Job">
				<th>Project #:</th>
				<td>{{ form.Job.job_num }}: {{ form.Job.job_name }}</td>
			</tr>
			<tr v-if="form.Service && 'id' in form.Service">
				<th>Service #:</th>
				<td>{{ form.Service.job_num }}: {{ form.Service.job_name }}</td>
			</tr>
			<tr>
				<th>Site Location:</th>
				<td v-if="form.Service && 'id' in form.Service">
					{{ form.Service.address }},{{ form.Service.city }}, {{ form.Service.province }}
				</td>
				<td v-else-if="form.Job && 'id' in form.Job">
					{{ form.Job.address }}, {{ form.Job.city }}, {{ form.Job.province }}
				</td>
			</tr>
			<tr v-if="'CustomerAsset' in form && form.CustomerAsset">
				<th>Customer Asset:</th>
				<td>{{ form.CustomerAsset.description }} (S/N {{ form.CustomerAsset.serial_num }})</td>
			</tr>
			<template v-if="'Equipment' in form && form.Equipment">
				<tr>
					<th>Equipment:</th>
					<td>{{ form.Equipment.description }} ({{form.Equipment.serial_num}})</td>
				</tr>
				<tr v-for="field in equipmentCustomFieldsToDisplay">
					<th>{{ field.label }}:</th>
					<td v-html="field.renderedValue"></td>
				</tr>
			</template>
		</table>
	</div>
	
	<form-static-render :form="formSections" :participants-prop="formParticipants" :print-view="true" :full-form="form"></form-static-render>

</article>
</template>
<script type="text/javascript">
import FormStaticRender from "@/components/company_forms/FormStaticRender"
import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "FormPrint",
	components: {
		FormStaticRender
	},
	data() {
		return {
			form: {},
			equipmentCustomFields: {}
		}
	},
	mixins: [
		FormMixins
	],
	computed: {
		formParticipants() {
			if ("CompanyFormAcknowledgement" in this.form)
				return this.form.CompanyFormAcknowledgement
			else
				return []
		},
		formSections() {
			try {
				let sections = JSON.parse(this.form.form_json)

				sections.forEach(section => {

					if ('fields' in section && Array.isArray(section.fields)) {

						section.fields.forEach(field => {

							// Legacy fix: field.conditionalImageResponseValue is now a LIST of images, instead of just one
							if ('conditionalImageResponseValue' in field && field.conditionalImageResponseValue) {

								if (!Array.isArray(field.conditionalImageResponseValue))
									field.conditionalImageResponseValue = [field.conditionalImageResponseValue]
							}
						})
					}
				})

				return sections
			}
			catch (e) {
				return []
			}
		},
		companyLogoSrc() {
			let vm = this

			if (this.form && "Company" in this.form && "ProfileImage" in this.form.Company && this.form.Company)
				return window.apiRoot+"resources/profile-images/"+this.form.Company.ProfileImage.slug+"/"+this.form.Company.ProfileImage.filename
			else
				return false
		},
		equipmentCustomFieldsToDisplay() {
			if (this.form && "Equipment" in this.form && this.form.Equipment && "EquipmentType" in this.form.Equipment && this.form.Equipment.EquipmentType) {
				let customFields = []
				try {
					customFields = JSON.parse(this.form.Equipment.EquipmentType.custom_fields_json)
				}
				catch (e) {}

				customFields = customFields.filter(field => "showOnCompanyForm" in field && field.showOnCompanyForm == 1)

				let customFieldValues = []
				try {
					customFieldValues = JSON.parse(this.form.Equipment.custom_fields_json)
				}
				catch (e) {}

				return customFields.map(field => {
					field.renderedValue = customFieldValues[field.label]

					if (field.type == 'boolean') {
						if (field.renderedValue == 0)
							field.renderedValue = "<i class='fa fa-times'></i>"
						else 
							field.renderedValue = "<i class='fa fa-check'></i>"
					}

					return field
				})

			}

			return []
		}
	},
	methods: {
		printPage() {
			window.print()
		},
		fetchForm() {
			let vm = this

			let params = {
				include: [
					"CompanyFormAcknowledgement",
					"CustomerAsset",
					{
						model: "Job",
						include: [{model: "User",fields: ["id","slug","first_name","last_name","phone_mobile"]}]
					},
					{
						model: "Service",
						include: [{model: "User",fields: ["id","slug","first_name","last_name","phone_mobile"]}]
					},
					{
						model: "Equipment",
						include: ["EquipmentType"]
					},
					{
						model: "Company",
						include: ["ProfileImage"]
					},
					{
						model: "FormChildTemplate",
						include: ["FormTemplate"]
					}
				]
			}

			this.spinner(true)

			this.getJSON("CompanyForm/find/"+this.$route.params.slug,params).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.form = response.data

					// Set formNum
					let formNum = vm.form.form_num.toString()  // pad with 0's
					while (formNum.length < this.formNumLength)
						formNum = "0" + formNum

					vm.form.formNum = formNum

					vm.equipmentCustomFields = {}
					try {
						vm.equipmentCustomFields = JSON.parse(this.form.Equipment.custom_fields_json)
					}
					catch (e) {}
				}
			})
		}
	},
	created() {
		let vm = this

		this.fetchForm()

		this.$store.printMode = true
	}
}	
</script>
